import React from 'react';

export interface SearchFilterProps {
  searchFilters: { id: string; name: string }[];
  selected: string[];
  translations: Record<string, { value: string }>;
  themeColor: string;
  onChange: (selected: string[]) => void;
}

export const SearchFilters: React.FC<SearchFilterProps> = ({
  searchFilters,
  selected,
  translations,
  themeColor,
  onChange,
}) => {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
      {searchFilters
        .sort((a, b) => {
          return a.name.localeCompare(b.name);
        })
        .map((searchFilter) => {
          return (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
            <div
              key={searchFilter.id}
              style={{
                backgroundColor: '#f1f1f1',
                padding: '6px',
                cursor: 'pointer',
                // emulate border using box shadow to prevent shifting of the layout
                // https://stackoverflow.com/a/19255041/749644
                boxShadow: selected.includes(searchFilter.id)
                  ? `0 0 0 2px ${themeColor}`
                  : 'none',
              }}
              onClick={() => {
                if (selected.includes(searchFilter.id)) {
                  onChange(selected.filter((id) => id !== searchFilter.id));
                } else {
                  onChange([...selected, searchFilter.id]);
                }
              }}
              className={`simple-store-locator-search-filter ${
                selected.includes(searchFilter.id)
                  ? 'simple-store-locator-search-filter-selected'
                  : 'simple-store-locator-search-filter-unselected'
              }`}
            >
              {translations[searchFilter.id]?.value || searchFilter.name}
            </div>
          );
        })}
    </div>
  );
};
